import { Injectable } from '@angular/core';
import { EditorialImageApiModel, ImageDataService } from '@cxb/editor-stb-api';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { UploadedFileData } from '../domain/uploaded-file';
import { apiErrorMessage } from '../shared/functions/general-api-error-handling';
import * as FileUploadActions from './file-upload.actions';

@Injectable()
export class FileUploadEffects {
  constructor(private readonly actions$: Actions, private readonly imageDataService: ImageDataService) {}

  public uploadFile$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FileUploadActions.uploadCxBFile),
      mergeMap((params: { file: File; clientId: string }) => {
        return this.imageDataService.uploadImages([params.file]).pipe(
          map((response) =>
            FileUploadActions.uploadCxBFileSuccess({
              uploadedFileData: this.mapApiModelUploadFileResponseToDomainModel(response, params.clientId),
            })
          ),
          catchError((error) => of(FileUploadActions.uploadCxBFileFail(apiErrorMessage(error))))
        );
      })
    )
  );

  public deleteFile$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FileUploadActions.deleteCxBFile),
      mergeMap(({ fileId }) => {
        return this.imageDataService.deleteImage(fileId).pipe(
          map((response) => FileUploadActions.deleteCxBFileSuccess({ fileId })),
          catchError((error) => of(FileUploadActions.deleteCxBFileFail(apiErrorMessage(error))))
        );
      })
    )
  );

  private mapApiModelUploadFileResponseToDomainModel(response: EditorialImageApiModel[], clientId: string): UploadedFileData {
    if (!response.length) {
      return;
    }
    const file = response[0];
    return {
      id: file.id,
      name: file.originalName,
      publicUrl: file.publicUrl,
      clientId,
    };
  }
}
